import { IRequestParams } from '@portals/fetch-api';
import { DEFAULT_API_CACHE_PARAMS } from '@/_constants/cache-params';
import { ERevalidatePeriods } from '@/api/constants';

export type TGetArticlesParams = {
  contentUrl: string;
};

export const makeRequestConfig = ({
  contentUrl,
}: TGetArticlesParams): IRequestParams => ({
  endpoint: contentUrl,
  browserCacheParams: {
    ...DEFAULT_API_CACHE_PARAMS,
    strategy: 'CacheFirst',
    requestCacheKey: contentUrl,
    expires: ERevalidatePeriods.TEN_MINUTES,
  },
});
